// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"VQ-z","tooltipWrapper":"WQ-z","icon":"XQ-z","tooltip":"YQ-z","content":"ZQ-z"};